import { render, staticRenderFns } from "./BiddingAmount.vue?vue&type=template&id=b4a8f98e&scoped=true&"
import script from "./BiddingAmount.vue?vue&type=script&lang=js&"
export * from "./BiddingAmount.vue?vue&type=script&lang=js&"
import style0 from "./BiddingAmount.vue?vue&type=style&index=0&id=b4a8f98e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a8f98e",
  null
  
)

export default component.exports